<template>
  <div class="complianceChecksWhitelistSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="4">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('alarms.common.pleaseSelectCompany')"
            @on-change="getAccountList"
            :transfer="true"
          >
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <!-- 选择账户 -->
      <Col span="4">
        <Select
          v-model="accountId"
          filterable
          :placeholder="$t('alarms.complianceChecks.PleaseSelectAccount')"
          @on-change="getRegionList"
          :transfer="true"
        >
          <Option
            :value="item.id"
            v-for="item in accountList"
            :key="item.name"
            >{{ item.name }}</Option
          >
        </Select>
      </Col>
      <!-- 选择存储区域 -->
      <Col span="4">
        <Select
          v-model="region"
          filterable
          :placeholder="$t('alarms.complianceChecks.PleaseSelectRegion')"
          @on-change="getConfigRuleList"
          :transfer="true"
        >
          <Option
            :value="item.name"
            v-for="item in regionList"
            :key="item.id"
            >{{ item.name }}</Option
          >
        </Select>
      </Col>
      <!-- 选择合规检查 -->
      <Col span="4">
        <Select
          v-model="configRule"
          filterable
          :placeholder="$t('alarms.complianceChecks.FilterbyComplianceRules')"
          :transfer="true"
        >
          <Option
            :value="item.configRuleName"
            v-for="(item, index) in configRuleNamesList"
            :key="index"
            >{{ item.configRuleName }}</Option
          >
        </Select>
      </Col>
      <Col span="4">
        <Input
          v-model="resourceName"
          :placeholder="$t('alarms.complianceChecks.SearchbyName')"
        />
      </Col>
      <Col span="4">
        <div>
          <Button
            type="primary"
            v-hasPermission="['monitor:complianceChecks:white_list_page']"
            @click="searchWhitelist"
            >{{ $t("message.select") }}</Button
          >
          <Button
            type="primary"
            v-hasPermission="[
              'monitor:complianceChecks:ignoreNoncompliantResources'
            ]"
            @click="addWhitelist"
            >{{ $t("alarms.complianceChecks.AddWhitelistResources") }}</Button
          >

          <add-compliance-checks-whitelist
            v-if="addWhitelistVisible"
            ref="addWhitelistVisible"
          ></add-compliance-checks-whitelist>
        </div>
      </Col>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";
import TableComplianceChecksWhitelist from "./TableComplianceChecksWhitelist";
import AddComplianceChecksWhitelist from "./AddComplianceChecksWhitelist";

const tableComplianceChecksWhitelist = TableComplianceChecksWhitelist;
export default {
  name: "ComplianceChecksWhitelistSearch",
  components: {
    AddComplianceChecksWhitelist,
    TableComplianceChecksWhitelist
  },
  data() {
    return {
      company: getCookie(global.companyId),
      companyId: 0,
      accountId: 0,
      region: "",
      companyList: [],
      accountList: [],
      regionList: [],
      resourceName: "",
      configRuleNamesList: [],
      configRule: "",
      addWhitelistVisible: false
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
  },
  methods: {
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    },
    // 根据公司或用户名查询Account列表
    getAccountList: function() {
      this.$api.account
        .getAWSAccountByCompanyId("companyId", this.companyId)
        .then(res => {
          this.accountList = res.data;
        });
    },
    // 选择地区
    getRegionList: function() {
      if (typeof this.accountId === "undefined") {
        return;
      }
      this.$api.account
        .queryAccountRegions("accountId", this.accountId)
        .then(res => {
          this.regionList = res.data;
        });
    },
    // 合规性查询
    getConfigRuleList: function() {
      this.$api.awsConfigCheckItem.queryConfigRuleCheckItems({}).then(res => {
        this.configRuleNamesList = res.data;
      });
    },
    // 按名称搜索
    searchWhitelist: function() {
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("accountId", this.accountId);
      eventBus.$emit("region", this.region);
      eventBus.$emit("resourceName", this.resourceName);
      eventBus.$emit("configRule", this.configRule);
      tableComplianceChecksWhitelist.methods.showAll();
    },
    addWhitelist: function() {
      this.addWhitelistVisible = true;
      this.$nextTick(() => {
        this.$refs.addWhitelistVisible.init();
      });
    }
  }
};
</script>
<style scoped>
.complianceChecksWhitelistSearch {
  height: 51px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/compliance_checks/complianceChecks_whitelist/ComplianceChecksWhitelistSearch.vue